












































































import {
  Vue,
  Prop,
  Emit,
  Component,
  Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import DialogConnector from '@/connector/Dialog.vue';

const Dialog = namespace('Dialog');

@Component({
  components: {
    DialogConnector,
  },
})
export default class TopgameDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  @Dialog.State
  public dialogData!: any;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  mounted() {
    const videoElement: HTMLVideoElement = (document.getElementById('topgame-video-mobile') as HTMLVideoElement);
    console.log('work');
    console.log('videoElement', videoElement);
    if (videoElement && this.$vuetify.breakpoint.mdAndDown) {
      console.log('work');
      videoElement.pause();
      videoElement.removeAttribute('src');
      videoElement.src = this.dialogData.video;
      videoElement.load();
      videoElement.play();
      videoElement.muted = false;
    }
  }
}
